import service from '../../utils/Service'

export default function getTemplateActivityTypes(region) {
   return {
      type : "GET_TEMPLATE_ACTIVITY_TYPES",
      payload : service.getTemplateActivityTypes(region)
   }
}




// WEBPACK FOOTER //
// ./src/actions/templates/getTemplateActivityTypesAction.js